import { deleteDB, type DBSchema, type IDBPDatabase, openDB } from "idb";

const DATABASE_NAME = "shotboard_local";
const DATABASE_VERSION = 2;

export interface RecentWorkspaceRecord {
  readonly id: string;
  readonly name: string;
  readonly handle: FileSystemDirectoryHandle;
  readonly lastOpenedAt: string;
}

export interface RecoveryRecord {
  readonly boardPath: string;
  readonly documentJson: string;
  readonly savedAt: string;
}

export interface RecentBoardRecord {
  readonly id: string;
  readonly workspaceId: string;
  readonly boardPath: string;
  readonly lastOpenedAt: string;
}

interface ShotboardDatabase extends DBSchema {
  workspaces: {
    key: string;
    value: RecentWorkspaceRecord;
  };
  recovery: {
    key: string;
    value: RecoveryRecord;
  };
  recent_boards: {
    key: string;
    value: RecentBoardRecord;
  };
}

/** Opens the browser-local support database without making it canonical. */
export function openLocalDatabase(): Promise<IDBPDatabase<ShotboardDatabase>> {
  return openDB<ShotboardDatabase>(DATABASE_NAME, DATABASE_VERSION, {
    upgrade(database, oldVersion) {
      if (oldVersion < 1) {
        database.createObjectStore("workspaces", { keyPath: "id" });
        database.createObjectStore("recovery", { keyPath: "boardPath" });
      }
      if (oldVersion < 2) {
        database.createObjectStore("recent_boards", { keyPath: "id" });
      }
    },
  });
}

/** Clears only the isolated local database between deterministic tests. */
export async function resetLocalDatabaseForTests(): Promise<void> {
  await deleteDB(DATABASE_NAME);
}
